import React from 'react'
import Header from '../../../../googleAd/shared/sections/Header'
import { FirstView } from '../../../shared/sections/FirstView'
import EntryForm from '../../../shared/forms/EntryForm'
import { naganoConfig } from './config.ts'
import { StepProvider } from '@/components/Context/StepContext'
import styles from './InstagramNaganoFormPage.module.css'
import { NaganoSpLandingPageProps } from './types.ts'
import { useAbTestGtm } from '@/components/utils/abTest'

const InstagramNaganoFormPage: React.FC<NaganoSpLandingPageProps> = ({ prefectures }) => {
    const { dataViewLabel } = useAbTestGtm()

    return(
        <div className={styles.InstagramNaganoFormPageWrap}>
            <StepProvider
                initialFormData={{
                    preferLineContact: true,
                    agreeTerms: true
                }}
                initialTouchedFields={{
                    preferLineContact: true,
                    agreeTerms: true,
                    channel: true
                }}
            >
                <Header id='renewal_top' dataViewLabel={dataViewLabel('HD')} />
                <FirstView dataViewLabel={dataViewLabel('CT_FirstView')}/>
                <div className={styles.formWrap}>
                    <EntryForm
                        prefectures={prefectures}
                        config={naganoConfig}
                    />
                </div>
            </StepProvider>
        </div>
    )
}

export default InstagramNaganoFormPage
